import { Suspense } from "react";
import * as React from "react";
import { ApolloProvider } from "@apollo/client";

import { useSessionCookie } from "hooks/useSessionCookie";
import { useApolloClient } from "hooks/useApolloClient";
import { Maintenance } from "components/Maintenance";
import { CenterSpinner } from "components/CenterSpinner";
import { Wrapper, Application } from "components/Application";

import "styles/base.less";

type RootProps = {
  debug: boolean;
  siteEnvironment: {
    name: string;
    maintenance: boolean;
    appEndpointCore: string;
    appEndpointStore: string;
    appEndpointOffice: string;
    appEndpointPublic: string;
    sessionCookie: string;
    sessionDomain: string;
  };
};

export const Root: React.FC<RootProps> = (props) => {
  const { debug, siteEnvironment } = props;

  const { token, setToken, clearToken } = useSessionCookie(
    siteEnvironment.sessionCookie,
    siteEnvironment.sessionDomain,
  );
  const apolloClient = useApolloClient(siteEnvironment.appEndpointCore, token, clearToken);

  const wrapperProps = {
    debug,
    siteEnvironment,
    token,
    setToken,
    clearToken,
  };

  if (siteEnvironment.maintenance === true) return <Maintenance />;

  return (
    <Suspense fallback={<CenterSpinner size="large" />}>
      <ApolloProvider client={apolloClient}>
        <Wrapper {...wrapperProps}>
          <Application />
        </Wrapper>
      </ApolloProvider>
    </Suspense>
  );
};
